import { Injectable } from '@angular/core';
import { getAgeFromDate2 } from '@wz-utilities/date.utilities';

@Injectable({
  providedIn: 'root',
})
export class AniService {
  constructor() {}

  //Si âge strictement inférieur à 55 ans alors date d'effet doit être supérieure à J+30 pour aller à l'étape suivante.
  //Si la date d'effet est inférieure à 30 jours il faudrait ajouter le message suivant :
  //"La date d'effet ne peut être inférieure à 30 jours "
  //Pour le cas d'un couple, les 2 adultes doivent avoir moins de 55 ans pour que le blocage fonctionne.

  isDateEffetValide(
    dateEffet: any,
    dateNaissanceAssure: any,
    dateNaissanceConjoint: any,
  ) {
    if (dateEffet) {
      if (dateNaissanceAssure && dateNaissanceConjoint) {
        if (
          this.isANI(dateNaissanceAssure) &&
          this.isANI(dateNaissanceConjoint)
        ) {
          if (!this.isDateEffetSuperior30Days(dateEffet)) return false;
        } else return true;
      } else if (
        dateNaissanceAssure &&
        this.isANI(dateNaissanceAssure) &&
        !dateNaissanceConjoint
      ) {
        if (!this.isDateEffetSuperior30Days(dateEffet)) return false;
        else return true;
      }
      return true;
    } else return false;
  }

  //Age < 55 ans
  isANI(dateNaissance: any): boolean | null {
    if (dateNaissance) {
      let age = getAgeFromDate2(dateNaissance);
      if (age < 55) return true;
      else return false;
    } else return null;
  }
  //Age > = 55 ans
  isHorsANI(dateNaissance: any): boolean | null {
    if (dateNaissance) {
      let age = getAgeFromDate2(dateNaissance);
      if (age && age >= 55) {
        return true;
      } else return false;
    } else return null;
  }

  isDateEffetSuperior30Days(date: string | Date): boolean {
    if (date) {
      // Convertir la date en objet Date si c'est une chaîne
      let targetDate: Date;

      if (typeof date === 'string') {
        // Convertir en format standard "yyyy-MM-dd"
        const parts = date.split('/');
        if (parts.length === 3) {
          targetDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`); // Reformater en yyyy-MM-dd
        } else {
          targetDate = new Date(date); // Autres formats compatibles
        }
      } else {
        targetDate = date;
      }

      //Vérifier is la chaine est valide
      if (isNaN(targetDate.getTime())) {
        throw new Error('Date invalide');
      }

      // Obtenir la date actuelle sans l'heure
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      // Calculer la différence en millisecondes
      const timeDiff = targetDate.getTime() - today.getTime();

      // Convertir la différence en jours
      const diffInDays = timeDiff / (1000 * 3600 * 24);

      // Vérifier si la date est >= 30 jours
      if (diffInDays >= 30) return true;
      else return false;
    } else return false;
  }
}
